// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-05-22T09:54:31Z                      #

// ##############################################################


/**
 * Vyjmenované hodnoty pro sign_Source.
 */
enum EnumSignSource {
    MC = 'MC', 
    REMSIG = 'REMSIG'
};
export default EnumSignSource;

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
const params = {
    [EnumSignSource.MC]: {caption: ''},
    [EnumSignSource.REMSIG]: {caption: ''}
};

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
export function getCaption(value) {
    return params[value].caption;
}
